import React from 'react'

import styled, { css } from 'styled-components'

import FlipMove from 'react-flip-move'
import { useStore } from '../zustandStore'

// import { EYES_EMOJI } from '../unicodeChars'
import { SafeImg } from '../components/SafeImgs'

import SubmissionsLargeEntry from '../obsSources/SubmissionsLargeEntry'
import SubmissionsLargeFullGameEntry from '../obsSources/SubmissionsLargeFullGameEntry'

import { customFadeOut } from '../customFlipMoveAnimations'

const PublicSubmissionsPage = (props) => {
  const { 
    event,
    playerCount,
    publicDisplayedSubmissions,
    disableSubmissionAnimations
  } = useStore(state => ({
    event: state.event,
    playerCount: state.players.length,
    publicDisplayedSubmissions: state.publicDisplayedSubmissions,
    disableSubmissionAnimations: !state.publicAppSettings.submissionAnimations
  }))

  const noSubmissions = !publicDisplayedSubmissions || publicDisplayedSubmissions.length === 0

  return (
    <FlipMove duration={800} maintainContainerHeight leaveAnimation={customFadeOut(0.4)} enterAnimation='fade' disableAllAnimations={disableSubmissionAnimations}>
      {noSubmissions ? (
        <NoSubmissionsMessage disableSubmissionAnimations={disableSubmissionAnimations} key={1}>
          {/* {disableSubmissionAnimations
            ? <SafeImg src={`/images/placeholders/blue_heart_216_static.png`} />
            : <SafeImg src={`/images/placeholders/all_hearts_216_animated.gif`} />
          } */}
          {disableSubmissionAnimations
            ? <SafeImg src={`/images/placeholders/celeste_berry_static.png`} />
            : <SafeImg src={`/images/placeholders/celeste_berry_animated.gif`} />
          }
          <div className='no-submissions-text'>
            No submissions yet...
          </div>
        </NoSubmissionsMessage>
      ) : (
        event.isFullGame ? (
          <FlipMoveStyleWrapperFullGame key={2} disableAllAnimations={disableSubmissionAnimations} duration={700}>
            {publicDisplayedSubmissions.map((submission) => 
              <SubmissionsLargeFullGameEntry
                key={submission.id}
                submission={submission}
                maxRankDigits={String(playerCount).length}
              />
            )}
          </FlipMoveStyleWrapperFullGame>
        ) : (
          <FlipMoveStyleWrapperIL key={3} disableAllAnimations={disableSubmissionAnimations} duration={700}>
            {publicDisplayedSubmissions.map((submission) => 
              <SubmissionsLargeEntry
                key={submission.id}
                submission={submission}
              />
            )}
          </FlipMoveStyleWrapperIL>
        )
      )}
    </FlipMove>
  )
}

export default PublicSubmissionsPage

const FlipMoveStyleWrapperFullGame = styled(FlipMove)`
  /* display: flex;
  flex-direction: column;
  justify-content: space-evenly; */

  /* height: 100vh; */
  max-width: 750px;
  margin: 0 auto;
  font-size: min(0.65em, 2vw);

  .submission-wrapper {
    margin: 0.3em auto;
    border-width: 1px;
  }
  .flag {
    --flag-width: 1.6em;
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .rank {
    font-size: 0.8em;
    font-weight: lighter;
    padding-top: 0.1em;
    .monospaced-char {
      flex-direction: column;
      justify-content: flex-end;
      padding: 0;
    }
  }

  .name {
    line-height: normal;
  }
`

const FlipMoveStyleWrapperIL = styled(FlipMove)`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;

  /* height: 100vh; */
  max-width: 750px;
  margin: 0 auto;
  font-size: min(0.65em, 2vw);

  .submission-wrapper {
    margin: 0.3em auto;
    border-width: 1px;
  }

  .player-title {
    font-size: 1.5em;
  }

  .name {
    line-height: normal;
  }

  .flag {
    --flag-width: 1.8em;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: auto calc(var(--flag-width) * 0.1) auto auto;
  }
  .rank {
    font-size: 0.8em;
    line-height: normal;
    padding: 0;
    font-weight: lighter;
  }
  .body-wrapper {
    grid-template-columns: 3em 1fr 1fr 1fr;
  }
  .total-header {
    font-size: 0.83em;
  }
  .sticker-wrapper {
    grid-row-start: 1;
    grid-row-end: none;
    grid-column: 1;
    min-width: 0.1em;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      padding-top: 5px;
      padding-bottom: 5px;

      max-height: 1.9em;
      max-width: 95%;
    }
  }
`

const NoSubmissionsMessage = styled.div`
  font-style: italic;
  opacity: 0.5;
  margin: 0 auto;
  font-size: min(2em, 7vw);
  text-align: center;
  display: grid;

  pointer-events: none;
  user-select: none;

  img, .no-submissions-text {
    grid-row: 1;
    grid-column: 1;
    margin-top: auto;
    margin-bottom: auto;
  }
  
  /* berry styling */
  --bounce-amplitude: 0.15em;
  /* heart styling */
  /* --bounce-amplitude: 0.2em; */
  --shift-image-down: 0.4em;
  img {
    /* heart exclusive */
    /* margin-top: var(--shift-image-down);
    margin-bottom: calc(-1 * var(--shift-image-down)); */
    

    z-index: -1;
    opacity: 0.25;
    max-width: 5em;
    margin-left: auto;
    margin-right: auto;

    ${props => !props.disableSubmissionAnimations && css`
      transform: translateY(calc(-1 * var(--bounce-amplitude)));
      animation: bounce 3.5s infinite cubic-bezier(0.45, 0.05, 0.55, 0.95);
    `}

  }

  @keyframes bounce {
    0%   { transform: translateY(calc(-1 * var(--bounce-amplitude)));}
    50%  { transform: translateY(var(--bounce-amplitude));}
    100% { transform: translateY(calc(-1 * var(--bounce-amplitude)));}
  }

`
